import { render, staticRenderFns } from "./orderInfoModal.vue?vue&type=template&id=67db3fb9&"
import script from "./orderInfoModal.vue?vue&type=script&lang=js&"
export * from "./orderInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports